import { createGlobalStyle } from 'styled-components';
// import variables from './variables';

const GlobalStyle = createGlobalStyle`


    @font-face {
        font-family: 'Font Awesome 5 Free';
        src: url('/assets/apps/reasons-why-app/assets/fonts/fontawesome/fa-solid-900.eot');
        src: url('/assets/apps/reasons-why-app/assets/fonts/fontawesome/fa-solid-900.eot?#iefix') format('embedded-opentype'),
            url('/assets/apps/reasons-why-app/assets/fonts/fontawesome/fa-solid-900.woff2') format('woff2'),
            url('/assets/apps/reasons-why-app/assets/fonts/fontawesome/fa-solid-900.woff') format('woff'),
            url('/assets/apps/reasons-why-app/assets/fonts/fontawesome/fa-solid-900.ttf') format('truetype'),
            url('/assets/apps/reasons-why-app/assets/fonts/fontawesome/fa-solid-900.svg#Font Awesome 5 Free') format('svg');
            font-weight:900;
        font-style: normal;

    }

    html {
        overflow-y: scroll; // avoids layout moving when scrollbar isn't needed
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    .nounderline {
        text-decoration: none !important;
    }

    body {
        //padding: 0;
        //margin: 0;
        overflow-x:hidden;
        font-family: Montserrat, sans-serif;
    }

    h1, h2, h3, h4, h5, h6, p, li {
        margin-top:0;
    }

    h5 {
        font-family: 'Montserrat', sans-serif !important;
        font-weight:500;
        font-size:19px;
    }

    strong {
        font-family: Montserrat-Regular, Arial, sans-serif !important;
        font-weight:700;
    }

    .nowrap {
        white-space:nowrap;
    }


`;

export default GlobalStyle;
